module.exports = __webpack_public_path__ + "img/img_two_retail@3x.a49dae88.png";